// The `AGStoreLocator` component allows users to search for local stores by entering a
// town or postcode. It uses React state to manage the search query, which is submitted
// via a form. When the search is triggered, the page redirects to a store locator page
// with the search query in the URL. The component displays an icon, a title, a description,
// and an input field where users can enter their location. It is styled with Tailwind CSS
// and includes validation for non-empty input before submission.

import React, { useState } from 'react';
import { MapPinIcon } from '@heroicons/react/24/outline';
import Typography from 'components/commercetools-ui/atoms/typography';
import Input from 'components/commercetools-ui/atoms/input';

const AGStoreLocator = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    if (searchQuery) {
      // Redirect to the find-stores page with the search query
      // window.location.href = `/find-stores?zipcity=${searchQuery}`;
      window.location.href = `/find-stores?q=${searchQuery}`;
    }
  };
  return (
    <>
      {' '}
      <div className="strore-locatore hidden bg-[#00805b] p-5 sm:flex">
        <div className="flex flex-col items-center gap-y-4 border border-white px-20 pb-80 pt-50">
          <MapPinIcon className="h-34 w-32 text-white" />
          <Typography className="my-5 text-center text-26 font-semibold leading-7 text-white">
            Find your local store
          </Typography>
          <Typography className="mb-10 text-center text-18 leading-5 text-white">
            85 stores nationwide so there is always one near you
          </Typography>
          <div className="w-[186px]">
            <form className="" onSubmit={handleSearch}>
              <div className="relative h-[40px]">
                <Input
                  className="border-none p-[0px] text-[13px]"
                  onChange={(e) => setSearchQuery(e.target.value)}
                  name="town-or-postcode"
                  value={searchQuery}
                  placeholder="Town or postcode"
                  isFooter={true}
                  labelPosition="inline"
                  isValid={searchQuery.length > 0}
                />
                <div className="absolute right-0 top-0">
                  <button
                    type="submit"
                    className="h-[40px] w-[64px] rounded-l-none bg-black px-16 font-semibold uppercase text-white"
                  >
                    Find
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AGStoreLocator;
